import GateTypeResourceInstance from "../../../../resources/expapiunified/GateType.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const {
  epic: gateTypesEpic,
  reducer: gateTypesReducer,
  actions: gateTypesActions,
  selectors,
  getDefaultReducerState: getDefaultGateTypesReducerState
} = createUnifiedRestApi(
  GateTypeResourceInstance,
  "gate-types",
  (state) => state.gateTypes
).create();
const {
  selectAll: selectAllGateTypes,
  selectById: selectGateTypeById,
  selectGetAsyncRequest: selectGetGateTypeAsyncRequest,
  selectQueryAsyncRequest: selectQueryGateTypesAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateGateTypeAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteGateTypeAsyncRequest
} = selectors;
const {
  getAsync: getGateTypeAsync,
  queryAsync: queryGateTypesAsync,
  createOrUpdateAsync: createOrUpdateGateTypeAsync,
  deleteAsync: deleteGateTypeAsync
} = gateTypesActions;
export {
  createOrUpdateGateTypeAsync,
  deleteGateTypeAsync,
  gateTypesEpic,
  gateTypesReducer,
  getDefaultGateTypesReducerState,
  getGateTypeAsync,
  queryGateTypesAsync,
  selectAllGateTypes,
  selectCreateOrUpdateGateTypeAsyncRequest,
  selectDeleteGateTypeAsyncRequest,
  selectGateTypeById,
  selectGetGateTypeAsyncRequest,
  selectQueryGateTypesAsyncRequest
};
//# sourceMappingURL=gate-types.js.map
